
import Links from '@library/components/Atoms/Link/Links.vue'
import ImageAtom from '@library/components/Atoms/Image/Image.vue'
export default {
  name: 'SideNavLanguage',
  components: {Links, ImageAtom},
  props: {
    activeMenu: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object,
      default: () => {}
    },
    userData: {
      type: Object,
      default: () => {}
    },
    text: {
      type: Object,
      default: () => {}
    },
    publicPath: {
      type: String,
      default: '/'
    },
    baseUrl: {
      type: String,
      default: ''
    },
    lang: {
      type: String,
      default: ''
    },
    baseUrlLang: {
      type: String,
      default: ''
    },
    b2bData: {
      type: Object,
      default: () => ({})
    },
    isAdminLoggedUs: {
      type: Boolean,
      default: false
    },
    isOnlyLanguages: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    akamaiCutting: '?output-quality=70&resize=114:*&composite-to=center,center|114:22&background-color=white',
    contracts: ['ELITE', 'MASTER', 'ADVANC', 'SMART'],
    logoIsLoaded: false
  }),
  mounted() {
    //Check if the logo is loading
    const logoImage = new Image()
    logoImage.onload = () => {
      this.logoIsLoaded = this.logoSrc ? true : false
    }
    logoImage.onerror = () => {
      this.logoIsLoaded = false
    }
    if (this.logoSrc) logoImage.src = this.logoSrc
  },
  computed: {
    logoSrc() {
      if (this.isB2B && this.userData?.partyId && this.b2bData?.tokenSSO) {
        return `/loadImage?id=${this.userData.partyId}&externalId=${this.userData.partyId}&logoName=Company&TOKENSSO=${this.b2bData.tokenSSO}`
      }
      if (this.programCard && this.category) {
        return `${this.publicPath}discovery/cards/${this.programCard}/${this.category}.png`
      }
      return null
    },
    isB2B() {
      return ['B2B_HOME', 'B2B_ADMIN'].includes(this.userData?.activeRol)
    },
    isAdminCGW() {
      return ['ROLE_ADM'].includes(this.userData?.activeRol)
    },
    userName() {
      const user = !this.isAdminLoggedUs ? this.userData?.loggedAs?.name : this.userData?.name
      const finalUser = user ? user : this.userData?.name
      try {
        return decodeURIComponent(finalUser)
      } catch (error) {
        return finalUser
      }
    },
    isGHAProgram() {
      return this.userData?.programs?.[0].includes('GHA')
    },
    programCard() {
      return this.isGHAProgram ? 'gha_discovery' : 'nh_discovery'
    },
    category() {
      return this.userData?.category ? this.userData?.category.toLowerCase() : ''
    },
    bonusAmount() {
      return this.userData?.bonusAmount
    },
    loggedMenuLinks() {
      let links
      if (this.isGHAProgram) {
        links = this.data?.ghaDiscoveryLoggedMenuLinks
      } else if (this.isB2B) {
        links = this.data?.b2bLoggedMenuLinks
      } else {
        links = this.data?.nhDiscoveryLoggedMenuLinks
      }
      const isParsed = this.hasRole('ROLE_B2E_FRIENDS') || this.hasRole('ROLE_EMPLEADO') || (this.hasRole('B2B_ADMIN') && this.userData?.rolName != 'VOUCHER')
      return isParsed ? this.loggedMenuLinksParsed(links) : links
    },
    subProgram() {
      return this.isGHAProgram ? this.userData?.cardNumber : this.userData?.programs?.[0].replace('_', ' ').replace('PLATINUM ', '')
    },
    isSubProgram() {
      return this.userData?.programs?.[0] != 'NH_DISCOVERY' && this.userData?.programs?.[0] != 'GHA_DISCOVERY'
    },
    isCompany() {
      return this.b2bData?.type == 'CO'
    },
    isAgency() {
      return this.b2bData?.type == 'AG'
    },
    hasCustomer() {
      return this.b2bData?.customer?.trim()
    },
    isNHPlus() {
      const company = this.b2bData?.contrato ? this.b2bData?.contrato : ''
      if (!company) return null
      const contracts = this.contracts
      return contracts.some(contract => company.includes(contract))
    },
    getContract() {
      const company = this.b2bData?.contrato
      if (!company) return null
      const contracts = this.contracts
      for (var key in contracts) {
        if (company.indexOf(contracts[key]) !== -1) {
          if (contracts[key] == 'ADVANC') return 'ADVANCE'
          return contracts[key]
        }
      }
      return null
    }
  },
  methods: {
    filterObject(key) {
      const texts = {}
      return texts[key]()
    },
    logo(key) {
      const logoData = {
        url: this.isGHAProgram ? this.data?.logoGHADiscovery?.url : this.data?.logoNHDiscovery?.url,
        title: this.isGHAProgram ? this.data?.logoGHADiscoveryTitleAlt?.content?.title : this.data?.logoNHDiscoveryTitleAlt?.content?.title,
        alt: this.isGHAProgram ? this.data?.logoGHADiscoveryTitleAlt?.content?.alt : this.data?.logoNHDiscoveryTitleAlt?.content?.alt
      }
      return logoData[key]
    },
    isObjectNull(obj) {
      if (typeof obj !== 'object') return false
      return obj === null || Object.keys(obj).length === 0
    },
    hasRole(role) {
      return this.userData?.activeRol === role
    },
    loggedMenuLinksParsed(loggedMenuLinks) {
      const listLogged = JSON.parse(JSON.stringify(loggedMenuLinks))
      const listLoggedAdmin = [JSON.parse(JSON.stringify(loggedMenuLinks?.[0]))]
      const disambiguation = {
        excludeB2b: 'No',
        blank: 'No',
        linkUrl: `${this.baseUrlLang}/disambiguation`,
        rel: 'follow',
        icon: {
          id: '385270',
          namespace: 'tcm',
          description: 'nh-ic-change',
          key: 'nh-ic-change',
          taxonomyId: '216010',
          title: 'nh-ic-change'
        },
        text: this.text.disambiguationText,
        title: 'Disambiguation'
      }
      listLogged.unshift(disambiguation)
      return this.isAdminLoggedUs ? listLoggedAdmin : listLogged
    },
    parseClass(val) {
      return val.toLowerCase()
    }
  }
}
